import { render, staticRenderFns } from "./studentHome.vue?vue&type=template&id=64bccbe3&scoped=true"
import script from "./studentHome.vue?vue&type=script&lang=js"
export * from "./studentHome.vue?vue&type=script&lang=js"
import style0 from "./studentHome.vue?vue&type=style&index=0&id=64bccbe3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bccbe3",
  null
  
)

export default component.exports